let themeCssTmpl = `
/* 主题色 */
.main-color {
  color: @color-text-main !important;
  border-color: @color-text-main !important;
}

.bg-main {
  background-color: @bg-main-color !important;
}

.bg-lightYellow {
  background-color: @bg-lightYellow !important;
}

.bg-lightColor {
  background-color: @bg-lightColor !important;
}

.linear-main1 {
  background-image: @linear-main1 !important;
}

.linear-main2 {
  background-image: @linear-main2 !important;
}

.linear-main3 {
  background-image: @linear-main3 !important;
}

.linear-main4 {
  background-image: @linear-main4 !important;
}

.ld-button.plain {
  background-color: @color-text-white;
  border: 1px solid @color-text-main;
  color: @color-text-main;
}

/* 首页背景图 */
.home-banner {
	background-image: @home-banner-url !important;
}

.tkQuery-banner {
	background-image: @tkQuery-banner-url !important;
}

.trQuery-banner {
	background-image: @trQuery-banner-url !important;
}

.htQuery-banner {
	background-image: @htQuery-banner-url !important;
}

.carQuery-banner {
	background-image: @carQuery-banner-url !important;
}


/* vant组件 样式覆盖 */
.van-address-edit__finish {
  color: @color-text-main;
}

.van-button--info {
  background-color: @bg-main-color;
}

.van-button--info {
  border-color: @color-text-main;
}

.van-button--plain.van-button--info {
  color: @color-text-main;
}

.van-checkbox__icon--checked .van-icon {
  background-color: @bg-main-color   !important;
  border-color: @color-text-main;
}

.van-tabs__line {
  background-color: @bg-main-color;
}

.van-contact-card--add .van-cell__left-icon {
  color: @color-text-main;
}

.van-dialog__confirm, .van-dialog__confirm:active {
  color: @color-text-main;
}

.van-dropdown-menu__title--active {
  color: @color-text-main;
}

.van-dropdown-item__option--active,
.van-dropdown-item__option--active .van-dropdown-item__icon {
  color: @color-text-main;
}

.van-nav-bar .van-icon {
  color: @color-text-main;
}

.van-nav-bar__text {
  color: @color-text-main;
}

.van-notify--primary {
  background-color: @bg-main-color;
}

.van-number-keyboard__close {
  color: @color-text-main;
}

.van-key--blue,
.van-key--blue.van-key--active {
  background-color: @bg-main-color;
}

.van-key--blue::after {
  border-color: @color-text-main;
}

.van-key--blue:active {
  background-color: darken(@bg-main-color, 10%);
}

.van-pagination__item {
  color: @color-text-main;
}

.van-pagination__item:active {
  background-color: @bg-main-color;
}

.van-pagination__item--active {
  background-color: @bg-main-color;
}

.van-picker__confirm {
  color: @color-text-main;
}

.van-picker__loading {
  color: @color-text-main;
}

.van-progress__portion {
  background-color: @bg-main-color;
}

.van-progress__pivot {
  background-color: @bg-main-color;
}

.van-radio__icon--checked .van-icon {
  background-color: @bg-main-color;
  border-color: @color-text-main;
}

.van-slider__bar {
  background-color: @bg-main-color;
}

.van-swipe__indicator--active {
  background-color: @bg-main-color;
}

.van-switch--on {
  background-color: @bg-main-color;
}

.van-switch--on .van-switch__loading {
  color: @color-text-main;
}

.van-tabbar-item--active {
  color: @color-text-main !important;
}

.van-tag--primary:not(.van-tag--plain) {
  background-color: @bg-main-color;
}

.van-tag--primary.van-tag--plain {
  color: @color-text-main;
}

.van-tabs--card {
  border-color: @color-text-main;
}

.van-tabs--card .van-tab {
  color: @color-text-main;
  border-color: @color-text-main;
}

.van-tabs__nav--card {
  border-color: @color-text-main;
}

.van-tabs--card .van-tab.van-tab--active {
  background-color: @bg-main-color;
}

.van-sidebar-item--select {
  color: @color-text-main;
  border-color: @color-text-main;
}

/* vant组件 样式覆盖 end */


/* 部分特殊页面 样式覆盖 */
.TrfilterPanel .train-filter-list .van-checkbox[aria-checked=true] {
  color: @color-text-main !important;
  border-color: @color-text-main !important;
  background-color: @bg-lightYellow !important;
}

.TrfilterPanel .train-filter-list .van-checkbox[aria-checked=true] .van-checkbox__label {
  color: @color-text-main !important;
}

.facedetection12306 {
  background-image: -webkit-linear-gradient(bottom, #eef2f7 70%, @bg-main-color 95%) !important;
}
/* 部分特殊页面 样式覆盖 end */
`

export default themeCssTmpl